// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  dirty: true,
  raw: 'v0.12.0-2-gc2b0581-dirty',
  hash: 'gc2b0581',
  distance: 2,
  tag: 'v0.12.0',
  semver: {
    raw: 'v0.12.0',
    major: 0,
    minor: 12,
    patch: 0,
    prerelease: [],
    build: [],
    version: '0.12.0'
  },
  suffix: '2-gc2b0581-dirty',
  semverString: '0.12.0+2.gc2b0581',
  version: '0.12.1'
};
/* tslint:enable */
